import { render, staticRenderFns } from "./FaoliyatOchiqligi.vue?vue&type=template&id=61be9f88&"
import script from "./FaoliyatOchiqligi.vue?vue&type=script&lang=js&"
export * from "./FaoliyatOchiqligi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports